exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.new-status-button{width:5em;height:5em;border-radius:100%;position:fixed;bottom:1.5em;right:1.5em;background-color:#182230;background-color:var(--btn, #182230);display:flex;justify-content:center;align-items:center;box-shadow:0px 2px 2px rgba(0,0,0,.3),0px 4px 6px rgba(0,0,0,.3);z-index:10;transition:.35s transform;transition-timing-function:cubic-bezier(0, 1, 0.5, 1)\n}\n.new-status-button.hidden{transform:translateY(150%)\n}\n.new-status-button svg{font-size:1.5em;color:#b9b9ba;color:var(--text, #b9b9ba)\n}\n@media all and (min-width: 801px){\n.new-status-button{display:none\n}\n}", ""]);

// exports
